import { combineReducers } from 'redux'
import { loginReducer } from './login-reducer'
import { refreshJwtReducer } from './refresh-jwt-reducer'

export const AuthReducer = combineReducers({
  login: loginReducer,
  refreshJwt: refreshJwtReducer,
})
